import DeleteOutlined from '@mui/icons-material/DeleteOutlined';
import { Button, Grid, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import SetupIndicator, { SetupStep } from 'v2/components/SetupIndicator/SetupIndicator';

interface Props {
  visitorGroupName: string;
  handleOpenDeleteVisitorGroupModal: () => void;
  setupSteps: [SetupStep, ...SetupStep[]];
  isDeleteVisitorGroupVisible: boolean;
}

const Header: React.FC<Props> = ({
  visitorGroupName,
  handleOpenDeleteVisitorGroupModal,
  setupSteps,
  isDeleteVisitorGroupVisible
}) => {
  const { translation } = useTranslation();

  return (
    <Grid container justifyContent="space-between">
      <Grid container direction="column">
        <Grid container spacing={2} alignItems="center">
          <Typography
            id="header-group-name"
            variant="h4"
            color="textPrimary"
            sx={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}
          >
            {visitorGroupName}
          </Typography>
          <SetupIndicator steps={setupSteps} />
        </Grid>
      </Grid>
      {isDeleteVisitorGroupVisible && (
        <Button
          id="delete-group-button"
          onClick={handleOpenDeleteVisitorGroupModal}
          size="small"
          color="error"
          variant="text"
          startIcon={<DeleteOutlined color="error" />}
        >
          {translation.delete_group}
        </Button>
      )}
    </Grid>
  );
};

export default Header;
